export default __webpack_public_path__ + "static/media/placeholder_dummy2016-physiotherapie01-de.9454847f.png";